import serverCode from '../../serverCode'

const defaultState = () => ({
  items: [],
  length: 0,
  paged: 0,
})

const state = defaultState()

const getters = {}

const mutations = {
  incrementPage(state) {
    state.paged++
  },
  setItems(state, payload) {
    state.length = payload.length
    state.items = state.items.concat(payload)
  },
  resetItems(state) {
    Object.assign(state, defaultState())
  },
}

const actions = {
  async getItems({ state, commit, rootState }, { perPage }) {
    try {
      const { succeed, reportArticles } = await serverCode(
        'getNewArrivalReportArticles',
        {
          offset: state.paged * perPage,
          perPage,
        },
        rootState.locale
      )
      if (!succeed) {
        throw new Error()
      } else {
        commit('setItems', reportArticles)
      }
    } catch (error) {
      //
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
